import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_v3/.local-data/work/popup-description-e63e908/build/src/app/global-error.tsx");
